// Main file, basically just loads the app file
require("./polyfills/polyfills.js");
import App from './components/app'
import React from 'react'
import ReactDOM from 'react-dom'

window.React = ReactDOM.render(<App />, document.getElementById('app'));
